<template>
  <div>
      <h1>Tjenesten er for tiden utilgjengelig</h1>
      <p>
        Vi beklager ulempene det måtte medføre. 
      </p>
  </div>
</template>

<script>
export default {
  name: 'Offline'
};
</script>
